import React from 'react'
import './publication.css'

function Volume25no12() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
        <h3 className="p-2" >Vol. 26, Nos. 1&2, Mar/Jun 2025</h3>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-26-no1&2/AspectsofYorubaPhonologyintheSpeechofIgedeYorubaBilingualResidentsAdeniyiK.pdf'><p> Aspects of Yoruba Phonology in the Speech of Igede-Yoruba Bilingual Migrants in 
Osun State, Nigeria - 
 <strong>Kolawole Adeniyi</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-26-no1&2/TimingLyricsinSelectedNigerianHipHopMusicAkindeleJAandFabunmiVA.pdf'><p>Timing Lyrics in Selected Nigerian Hip Hop Music and the Implication for 
Nigerian English Rhythm - 
<strong> Julianah Ajoke Akindele & Victor Ayomide </strong> - 14 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-26-no1&2/MetaphoricalStudyofAchebeandAdichieJamesAandSongdenRJ.pdf'><p>A Metaphorical Study of Achebe’s Things Fall Apart and Adichie’s Purple Hibiscus. -  
 <strong>Anthony James & Rejoice James Songden </strong> - 39 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-26-no1&2/ReevaluationoftheEnglishFrenchStressPatternsOmageEkwuemeandOlumese.pdf'> <p> A Re-evaluation of the English-French Stress Patterns: A Case for Anglophone Speakers/Learners of French in Nigeria - 
 <strong> Paschal Dada Omage, Chinyere Uchegbu-Ekwueme & Patience Ebanehita Olumese </strong> - 53 </p></a>
               </div>
              <div className="p-2">
              <a href= '/volume-26-no1&2/MorphophonemicStudyofUmunzePersonalNamesOnahPandPEze.pdf'> <p> A Morpho-phonemic Study of Umunze Personal Names, Southeastern Nigeria - 
 <strong> Patrick Onah and Patricia Eze </strong> - 64 </p></a>
               </div>   
               <div className="p-2">
              <a href= '/volume-26-no1&2/NewContrastiveAnalysisofthePronunciationofVowelSoundsSondeFakiyesiandAdejumo.pdf'> <p>A Contrastive Analysis of the Pronunciation of Vowel Sounds among Yoruba-English Bilingual Students in Southwest Nigeria  - 
 <strong> Simeon Olufunso Sonde, Temitope Morenike Fakiyesi & Olubunmi Lydia Adejumo</strong> - 79 </p></a>
               </div>
               <div className="p-2">
              <a href= '/volume-26-no1&2/BookReviewACriticalExamination-Eyeh,S.O.pdf'> <p>Book Review: A Critical Examination of Zainab Alkali and AI Imfeld’s Vultures in the Air: Voices from Northern Nigeria as 21st Century Northern Nigerian Literature - 
 <strong> Stephen O. Eyeh</strong> - 96 </p></a>
               </div>  
               <div className="p-2">
              <a href= '/volume-26-no1&2/ConversationalIntonationPatterns,Adejuwon,A.O.andFaleye,J.O.pdf'> <p>Conversational Intonation Patterns in the “Wh-” Question Utterances of Some Educated Nigerian Users of English - 
 <strong> Anthony Olabiyi Adejuwon & James Oladunjoye Faleye</strong> - 103 </p></a>
               </div>  
            <hr/>

        </section> 
    </div>
  )
}

export default Volume25no12;